import { computed, ref, watch } from 'vue'

export type LayoutMode = 'vertical' | 'horizontal'

const STORAGE_KEY = 'vetcrecon.layout-mode'
const mode = ref<LayoutMode>(typeof window !== 'undefined' && window.localStorage.getItem(STORAGE_KEY) === 'horizontal' ? 'horizontal' : 'vertical')

watch(mode, (value) => {
  if (typeof window !== 'undefined') window.localStorage.setItem(STORAGE_KEY, value)
})

export function useLayoutMode() {
  return { mode, isHorizontal: computed(() => mode.value === 'horizontal'), setMode: (value: LayoutMode) => (mode.value = value) }
}
